import React, { useEffect, useState } from 'react';
import {
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	ResponsiveContainer,
} from 'recharts';
import { transformPageViewsData } from '../utils/transformAPIResponse';
import { Box, Typography } from '@mui/material';

// Function to truncate long titles
const truncate = (str: string, maxLength: number) => {
	if (window.location.origin.includes('socketmat')) {
		// hardcoding for the demoing canreports to socketmat
		if (str.includes('not set')) {
			return 'Home';
		}
	}
	return str.length > maxLength ? str.substring(0, maxLength) + '...' : str;
};

// Component to render the page views chart
const PageViewsChart: React.FC<{
	apiResponse: AnalyticsApiResponse | null;
}> = ({ apiResponse }) => {
	const [pageViewsData, setPageViewsData] = useState<PageViewsData[]>([]);

	useEffect(() => {
		if (!apiResponse) return;
		const transformedData = transformPageViewsData(apiResponse);
		setPageViewsData(transformedData);
	}, [apiResponse]);

	return (
		<Box sx={{ overflowX: 'auto', overflowY: 'hidden' }} m={2}>
			{window.location.origin.includes('socketmat') && (
				<Typography>
					<strong>Total number of pages:</strong>: 2
				</Typography>
			)}

			<ResponsiveContainer width="100%" height={400} minWidth={1000}>
				<BarChart
					data={pageViewsData}
					margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
				>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis
						dataKey="pageTitle"
						tickFormatter={(value) => truncate(value, 5)} // Truncate to 20 characters
					/>
					<YAxis
						dataKey="screenPageViews"
						label={{
							value: '#Page Views',
							angle: -90,
							position: 'insideLeft',
						}}
					/>
					<Tooltip />
					<Bar dataKey="screenPageViews" fill="#8884d8" />
				</BarChart>
			</ResponsiveContainer>
		</Box>
	);
};

export default PageViewsChart;
